import React, {useCallback, useState} from 'react';
import styled from 'styled-components';

import Icon, {IconSize} from '../../../Icon/Icon';
import {GenericIconName} from '../../../Icon/IconName';
import {darkGrayColor} from '../../../constants/colors';
import {mediaMinDesktop} from '../../../constants/customMedia';
import {
  fsM,
  fsXS,
  fsXXS,
  fwBold,
  fwMediumBold,
} from '../../../constants/typography';
import {ModalDialog} from '../../../utilityComponents/ModalDialog/ModalDialog';

export const DetailArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: auto;
  padding: 18px 18px 24px;

  @media ${mediaMinDesktop} {
    padding: 36px;
  }
`;

export const StyledHeadline = styled.div`
  display: inline-flex;
  font-size: ${fsM}px;
  align-items: center;
  ${fwBold}
  line-height: 1.2;

  @media ${mediaMinDesktop} {
    margin-bottom: 34px;
  }
`;

const StyledSubline = styled.div`
  font-size: ${fsXS}px;
  ${fwMediumBold}
  line-height: 1.29;
  color: ${darkGrayColor};
  margin-bottom: 6px;
`;

export const StyledDescription = styled.div`
  display: none;
`;

const StyledDescriptionInModal = styled.div`
  font-size: ${fsXXS}px;
  ${fwMediumBold}
  line-height: 1.5;
  margin-top: 13px;
`;

export const StyledInfoIcon = styled(Icon)`
  cursor: pointer;
  margin-left: 2.5px;
`;

interface Props {
  headline?: string;
  subline?: string;
  informationText?: string;
  CTAButton?: React.ReactElement;
  showInformationText?: boolean;
}

export const DropInfo: React.FC<Props> = ({
  headline,
  subline,
  informationText,
  CTAButton,
  showInformationText = true,
}) => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  const handleOpenInfoModalClick = useCallback(
    (event: React.SyntheticEvent) => {
      event.stopPropagation();
      setShowInfoModal(true);
    },
    [],
  );

  const handleCloseInfoModalClick = useCallback(() => {
    setShowInfoModal(false);
  }, []);
  return (
    <DetailArea>
      <div>
        {subline && <StyledSubline>{subline}</StyledSubline>}

        {headline && (
          <StyledHeadline>
            {headline}

            {showInformationText && informationText && (
              <StyledInfoIcon
                asset={GenericIconName.IcInfo}
                size={IconSize.S}
                onClick={handleOpenInfoModalClick}
              />
            )}
          </StyledHeadline>
        )}
        {showInformationText && informationText && (
          <StyledDescription>{informationText}</StyledDescription>
        )}
      </div>
      {CTAButton}

      {showInfoModal && (
        <ModalDialog
          open={showInfoModal}
          onClose={handleCloseInfoModalClick}
          showCloseIcon={true}
          styles={{
            modal: {
              alignSelf: 'center',
              height: 'auto',
              padding: '30px 20px',
              top: 0,
            },
          }}
        >
          <StyledHeadline>{headline}</StyledHeadline>
          <StyledDescriptionInModal>{informationText}</StyledDescriptionInModal>
        </ModalDialog>
      )}
    </DetailArea>
  );
};
